import { getCookie } from './auth'

export function parseJwt (token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

export function getName () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.ad_soyad
}

export function getMail () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.eposta
}

export function getRole () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.yetki
}
export function getID () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.kisi_id
}

export function getIl () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.il_id
}

export function getBolge () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.bolge_id
}

export function getIlce () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.ilce_id
}

export function getCinsiyet () {
  const token = getCookie('tokenGrupTakip')
  const parsedJWT = parseJwt(token)
  return parsedJWT.cinsiyet
}
